export default from './RouterTest';



// WEBPACK FOOTER //
// ./src/views/RouterTest/index.js